import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import {
  Paper, Typography, IconButton,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import Grid from '@mui/material/Grid2';
import { TipusMovIcon, ConcepteIcon } from './IconMap.js';
import { strDateToDDMMYYYY } from '../../functions/formatDate.js';
import { formatEuro } from '../../functions/formatNumber.js';
import useBack from '../../hooks/useBack.js';
import AppContext from '../AppContext.js';
import { getColorForAmount } from '../../functions/colors.js';


// Afegim userapp a les props, ja que la pàgina contenedora (DetallMovimentPage) el rep de la ruta.
const DetallMovimentComponent = ({ data, userapp }) => {
    
    const navigate = useNavigate();
    const { onBack } = useBack();
    const { conceptesList } = useContext(AppContext);

    const handleNavigate = (to, params={}) => {
        //console.log('Intenta redirigir a:', to);
        navigate(to, params);
    };

    return (
        <Grid container spacing={2} padding={2} >
        <Grid size={12} display="flex" justifyContent="space-between" alignItems="center">
            <Grid display="flex" alignItems="center">
            <IconButton onClick={onBack}>
                <ArrowBack />
            </IconButton>
            <Typography variant="h5">Detall Moviment</Typography>
            {/*
            <IconButton onClick={()=>handleNavigate('/PISMANRESA/cmovdetail/55606', { replace: true })}>
                <ArrowBack />
            </IconButton>          
            */}
            </Grid>
        </Grid>

        {/* Ajustem el Grid per ocupar l'amplada completa */}
        <Grid size={12}> 
            <Paper sx={{ padding: '16px', mb: 2 }}>
            <Grid container spacing={1}>
                <Grid size={6}>
                <Typography variant="body1"><strong>Id Moviment:</strong> {data.id}</Typography>
                </Grid>
                <Grid size={6}>
                <Typography>
                    <strong>Tipus:</strong>
                    <TipusMovIcon tipus={data.tipus} />
                </Typography>
                </Grid>
                <Grid size={6}><Typography><strong>Data original:</strong> {strDateToDDMMYYYY(data.dataOrig)}</Typography></Grid>
                <Grid size={6}><Typography><strong>Moviment:</strong> {data.moviment}</Typography></Grid>
                <Grid size={6}><Typography><strong>Importe Original:</strong> {formatEuro(data.importOrig)}</Typography></Grid>
            </Grid>
            </Paper>


            <Paper sx={{ padding: '16px', mb: 2 }}>

            <Grid container spacing={1}>
            <Grid size={6}><Typography><strong>Compte:</strong> {data.pantallaOrigenDades}</Typography></Grid>
            <Grid size={6}><Typography><strong>Entitat:</strong> {data.entitatOrigen}</Typography></Grid>
            <Grid size={6}><Typography><strong>Contracte:</strong> {data.contracte}</Typography></Grid>
            <Grid size={6}><Typography><strong>Estat registre:</strong> {data.estat}</Typography></Grid>
            <Grid size={6}><Typography><strong>Data Valor:</strong> {strDateToDDMMYYYY(data.dataValor)}</Typography></Grid>
            <Grid size={6}><Typography><strong>Saldo:</strong> {formatEuro(data.saldo)}</Typography></Grid>
            <Grid size={6}><Typography><strong>Info:</strong> {data.mesInfo ? data.mesInfo : 'N/D'}</Typography></Grid>
            <Grid size={6}><Typography><strong>+Info:</strong> {data.mesInfoDetall ? data.mesInfoDetall : 'N/D'}</Typography></Grid>
            <Grid size={6}><Typography><strong>Data Registre Mov:</strong> {strDateToDDMMYYYY(data.itimestamp)}</Typography></Grid>
            </Grid>

            </Paper>

            {/* Taula de Conceptes Associats */}
            {/* Comprovem si existeix data.conceptes i si té elements */}
            {data.conceptes && data.conceptes.length > 0 && (
            () => {
                const totalConceptesImport = data.conceptes.reduce((sum, concepte) => sum + (concepte.importe || 0), 0);
                // Comprovem si data.importOrig existeix i és un número abans de comparar
                const importOrigValid = typeof data.importOrig === 'number';
                const isTotalMatch = importOrigValid && data.importOrig === totalConceptesImport;
                const totalColor = isTotalMatch ? 'green' : 'red';
                return (
                <Paper sx={{ padding: '16px', mt: 2 }}>
                    <Typography variant="h6" gutterBottom>
                        Conceptes Associats
                    </Typography>
                    <TableContainer>
                        <Table stickyHeader aria-label="taula de conceptes associats">
                            <TableHead> {/* El backgroundColor es mourà a les cel·les individuals */}
                                <TableRow sx={{
                                    borderBottom: '2px solid #ddd',
                                    '& th': { // Aplica a totes les TableCell dins d'aquest TableRow de capçalera
                                        backgroundColor: '#f0f0f0', // Assegura el fons per a cada cel·la
                                        fontWeight: 'bold',
                                        color: '#000',
                                        borderBottom: 'none' // Manté la vora inferior única del TableRow
                                    }
                                }}>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Concepte</TableCell>
                                    <TableCell align="right">Import</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.conceptes.map((concepteItem) => {
                                    const conceptObj = conceptesList?.find(c => c.nom === concepteItem.concepte);
                                    const isInvestment = conceptObj?.tipus === 'INVERSIO';
                                    const colorImport = getColorForAmount(concepteItem.importe, isInvestment);
                                    return (
                                        <TableRow
                                            hover
                                            key={concepteItem.id}
                                            onClick={() => handleNavigate(`/${userapp}/cmovdetail/${concepteItem.id}`)}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <TableCell>{strDateToDDMMYYYY(concepteItem.data)}</TableCell>
                                            <TableCell sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <ConcepteIcon concept={concepteItem.concepte} />
                                            </TableCell>
                                            <TableCell align="right" sx={{ color: colorImport, fontWeight: 'bold' }}>
                                                {formatEuro(concepteItem.importe)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            {/* Només mostrem el footer si hi ha més d'un concepte */}
                            {data.conceptes.length > 1 && (
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={2} align="right" sx={{ fontWeight: 'bold', borderBottom: 'none' }}>
                                            Total Conceptes:
                                        </TableCell>
                                        <TableCell
                                            align="right"
                                            sx={{
                                                fontWeight: 'bold',
                                                color: totalColor,
                                                borderBottom: 'none',
                                                fontSize: '1.1rem' // Augmentem la mida de la font per al total
                                            }}>
                                            {formatEuro(totalConceptesImport)}
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            )}
                        </Table>
                    </TableContainer>
                </Paper>
             )})()}
        </Grid>
        </Grid>
    )
};

export default DetallMovimentComponent;